import apiFetch from '@scale/frontend-lib/api-fetch';

export async function getDocumentAIGOProjectMetrics(
  projectIds: string[],
  startDate: string,
  endDate: string,
) {
  const getProjectMetricsResult = await apiFetch(
    null,
    `internal/document-project-metrics/metrics/document_ai_go/${projectIds.join(
      ',',
    )}/${startDate}/${endDate}`,
    {
      method: 'GET',
    },
  );
  return getProjectMetricsResult;
}

export async function getEnterpriseProjectMetrics(
  projectIds: string[],
  startDate: string,
  endDate: string,
) {
  const getProjectMetricsResult = await apiFetch(
    null,
    `internal/document-project-metrics/metrics/enterprise/${projectIds.join(
      ',',
    )}/${startDate}/${endDate}`,
    {
      method: 'GET',
    },
  );
  return getProjectMetricsResult;
}

export async function refreshMetrics(projectIds: string[]) {
  const getProjectMetricsResult = await apiFetch(
    null,
    `internal/document-project-metrics/refresh`,
    {
      method: 'POST',
      body: { projectIds },
    },
  );
  return getProjectMetricsResult;
}

export async function getProjectMetricsConfig(projectId: string) {
  const getProjectMetricsResult = await apiFetch(
    null,
    `internal/document-project-metrics/metrics-config/${projectId}`,
    {
      method: 'GET',
    },
  );
  return getProjectMetricsResult;
}
